import { isApiError } from "@sagot/api-client";
import { consoleRoutes } from "@sagot/constants";
import { useTranslation } from "@sagot/i18n";
import { AppLink, Badge, Button, Icon } from "@sagot/ui";
import { useId } from "react";
import { useWorkspaceContext } from "../../../session/workspace-context";

const PAYMENT_REQUIRED = 402;

/** 402 = the feature (or model) is outside the workspace's plan. */
export function isPlanGate(error: unknown): boolean {
  return isApiError(error) && error.status === PAYMENT_REQUIRED;
}

/** Upgrade card rendered whenever an endpoint answers 402. */
export function UpgradeCard({ feature, description }: { feature: string; description?: string }) {
  const { t } = useTranslation();
  const { summary } = useWorkspaceContext();
  const titleId = useId();
  return (
    <section className="card card-body flex flex-col gap-4 md:flex-row md:items-center" aria-labelledby={titleId} data-testid="plan-gate">
      <span className="inline-flex size-12 shrink-0 items-center justify-center rounded-lg bg-primary-soft text-primary-ink">
        <Icon name="sparkles" className="size-6" />
      </span>
      <div className="min-w-0 flex-1">
        <div className="flex flex-wrap items-center gap-2">
          <h2 id={titleId} className="text-base font-bold">
            {t("build.planGate.title", { feature })}
          </h2>
          <Badge tone="neutral">
            <Icon name="lock" className="size-3" />
            {t("build.planGate.badge")}
          </Badge>
        </div>
        <p className="mt-1 text-sm text-fg-muted">{description ?? t("build.planGate.body")}</p>
      </div>
      <Button asChild>
        <AppLink href={consoleRoutes.billing(summary.slug)}>
          <Icon name="arrow-up-right" />
          {t("build.planGate.upgrade")}
        </AppLink>
      </Button>
    </section>
  );
}
